import './styles.css';
import {ReactComponent as Icon} from "../../icons/filter-icon.svg";
import {ReactComponent as FilledIcon} from "../../icons/filtect-icon-filled.svg";

import {useState} from "react";
import {useSelector} from "react-redux";
import {getLanguage} from "../LanguageModal/reducer";
import translations from "../LanguageModal/translations";


export default function FilterComponent(props) {
    const {open, onChange} = props;
    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    return (
        <div className="filter-btn-ctn" onClick={() => onChange(!open)}>
            {open ? <Icon width="21" height="21"  alt="filter"/> : <FilledIcon width="21" height="21"  alt="filter"/>}
            <div className="filter-btn-text">{t('filter')}</div>
        </div>
    )
}